import { Theme } from '@mui/material';

export const MuiPickersCalendarHeader = {
  styleOverrides: {
    label: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.surface.onSurfaceVar,
    }),
    switchViewButton: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.surface.onSurfaceVar,
    }),
  },
};
